var _rect, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    stroke: "#d5715d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 18,
    rx: 2,
    ry: 2,
    width: 18,
    x: 3,
    y: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 16,
    y1: 2,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 8,
    y1: 2,
    y2: 6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 21,
    y1: 10,
    y2: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderIcon);
export default __webpack_public_path__ + "static/media/reminderIcon.5d9f871c13b3550bbb69f176967681a8.svg";
export { ForwardRef as ReactComponent };